import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppMaterialModule} from '@app/app-material.module';
import {ForbiddenComponent} from '@app/forbidden.component';
import {SentryErrorHandler} from '@app/services/sentry-error.handler';
import {environment} from '@environment';
import {BASE_PATH, Configuration} from '@gt-api';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HotkeyModule, HotkeyOptions} from 'angular2-hotkeys';
import {ApiMocksModule} from './api-mocks.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ServiceProviderModule} from './service-provider/service-provider.module';
import {GtRequestInterceptor} from './services/gt-request.interceptor';
import {GtWebSocketService} from './services/push-event/push-event.service';
import {SharedModule} from './shared/shared.module';

export function apiConfigurationFactory(): Configuration {
  return new Configuration({withCredentials: true});
}

export function apiUrlFactory(): string {
  return environment.apiUrl;
}

export function errorHandlerFactory(): ErrorHandler {
  if (environment.enableSentry) {
    return new SentryErrorHandler();
  } else {
    return new ErrorHandler();
  }
}

const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

@NgModule({
  declarations: [AppComponent, ForbiddenComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppMaterialModule.forRoot(),
    ApiMocksModule.forRoot(apiConfigurationFactory),
    ServiceProviderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      isolate: true
    }),
    HotkeyModule.forRoot(),
    SharedModule.forRoot(),
    AppRoutingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GtRequestInterceptor,
      multi: true
    },
    {provide: BASE_PATH, useFactory: apiUrlFactory},
    {provide: ErrorHandler, useFactory: errorHandlerFactory},
    {provide: HotkeyOptions, useValue: {}},
    GtWebSocketService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
